import {
    FETCH_PIANOTECHPIANO_LIST_STARTED,
    FETCH_PIANOTECHPIANO_LIST_SUCCEEDED,
    FETCH_PIANOTECHPIANO_LIST_FAILED,
    FIND_PIANOTECHPIANO_STARTED,
    FIND_PIANOTECHPIANO_SUCCEEDED,
    FIND_PIANOTECHPIANO_FAILED,
    SAVE_PIANOTECHPIANO_STARTED,
    SAVE_PIANOTECHPIANO_SUCCEEDED,
    SAVE_PIANOTECHPIANO_FAILED,
    RETURN_TO_PIANOTECHPIANO_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHPIANO_MODIFIED,
    PIANOTECHPIANO_VALIDATE,
    FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_STARTED,
    FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_SUCCEEDED,
    FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_FAILED,
    PIANOTECHPIANO_UPDATE_PIANO_LIST,
} from '../actions/PianoTechPianoActions';

import {
    LOGIN_VALIDATE_USER_SUCCESS
} from '../actions/LoginActions';

import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHPIANO_LIST,
    VIEW_PIANOTECHPIANO_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
} from '../app-constants';

const initialState = {
    pianoTechPianoList: [],
    pianoTechPiano: null,
    originalPianoTechPiano: null,
    view: VIEW_PIANOTECHPIANO_LIST,
};
const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHPIANO_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechPiano list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechPianoList: [],
            }

        case FETCH_PIANOTECHPIANO_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechPianoList: action.pianoTechPianoList,
                message: 'PianoTechPiano list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHPIANO_LIST_FAILED:

            return {
                ...state,
                pianoTechPianoList: [],
                message: 'Error trying to retrieve PianoTechPiano list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHPIANO_LIST:

            return {
                ...state,
                pianoTechPiano: null,
                originalPianoTechPiano: null,
                message: '',
                view: VIEW_PIANOTECHPIANO_LIST
            }

        case SWITCH_EDIT_TYPE:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechPiano: action.pianoTechPiano,
            }

        case FIND_PIANOTECHPIANO_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechPiano.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechPiano: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
            }

        case FIND_PIANOTECHPIANO_SUCCEEDED:

            return {
                ...state,
                pianoTechPiano: action.pianoTechPiano,
                originalPianoTechPiano: action.originalPianoTechPiano,
                message: 'PianoTechPiano successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHPIANO_UPDATE,
            }

        case FIND_PIANOTECHPIANO_FAILED:

            return {
                ...state,
                pianoTechPiano: null,
                message: 'Error trying to find PianoTechPiano.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHPIANO_MODIFIED:

            return {
                ...state,
                pianoTechPiano: action.pianoTechPiano,
                message: '',
            }

        case SAVE_PIANOTECHPIANO_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHPIANO_SUCCEEDED:

            return {
                ...state,
                pianoTechPiano: action.pianoTechPiano,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                maintenanceType: MAINTENANCE_TYPE_COMPLETE,
            }

        case SAVE_PIANOTECHPIANO_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHPIANO_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        case FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechPiano list for company.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechPianoList: [],
            }

        case FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_SUCCEEDED:

            return {
                ...state,
                pianoTechPianoList: action.pianoTechPianoList,
                message: 'PianoTechPiano list for company successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_FAILED:

            return {
                ...state,
                pianoTechPianoList: [],
                message: 'Error trying to retrieve PianoTechPiano list for company.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case LOGIN_VALIDATE_USER_SUCCESS:

            return {
                ...state,
                pianoTechPianoList: action.pianoTechPianoList,
            }

        case PIANOTECHPIANO_UPDATE_PIANO_LIST:

            return {
                ...state,
                pianoTechPianoList: action.pianoTechPianoList,
                pianoTechPiano: action.pianoTechPiano,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
            }

        default:
            return state;
    }
}


export default reducerOutput;
